import {DefaultProcessor} from "./default/processor";

export function get_processor(processor: string): DefaultProcessor {
  return new DefaultProcessor();
}
